// 简体中文语言包
export default {
	// 导航
	nav: {
		home: '首页',
		about: '关于我们',
		strategy: '投资策略',
		riskCompliance: '风控合规',
		crossBorder: '全球视野',
		business: '软件下载',
		contact: '联络我们',
		langSwitch: '繁',
	},

	// 通用（Header/Footer共用）
	common: {
		companyShort: '奥盛资产',
		companyFull: '奥盛资产管理有限公司',
		quickLinks: '快速链接',
		contactTitle: '联系方式',
	},

	// 首页 - Hero区域
	hero: {
		enTitle: 'A.C Asset Management Limited · 奥盛资产',
		tags: ['香港国际金融中心', '成立于2016', '专业投资者', '跨境资产配置'],
		subtitle: '多策略 · 风险优先',
		title: '跨市场 · 多策略 · 长期价值',
		description: '奥盛资产成立于2016年，立足香港国际金融中心，聚焦专业投资者资产配置需求，构建研究驱动、风险优先、多策略协同的资产管理体系，致力于在复杂市场环境中实现长期稳健回报。',
		ctaWhitepaper: '查看白皮书',
		ctaVideo: '观看公司视频',
	},

	// 首页 - 公司简介
	intro: {
		enTitle: 'INSTITUTIONAL WEALTH',
		title: '立足香港，连接全球资本与中国市场',
		description: '奥盛资产依托香港国际金融市场优势，结合系统化研究与资产配置能力，持续关注全球资本流动与中国市场机会，为专业投资者提供长期资产配置支持。',
		highlight1: '资产管理',
		highlight2: '证券投资',
		highlight3: '投资顾问',
		companyInfo: '公司深耕**资产管理**、**证券投资**与**投资顾问**服务，坚持合规运营、风控先行。旗下盛维量研聚焦量化研究、智能策略与风险控制，并聘请亿博资产创始人沈志远先生担任首席战略官，为用户提供更专业、更稳健的服务支持。',
		foundedDate: '2016.04.28',
		foundedLabel: '公司于香港注册成立',
		companyNumber: 'BHS283',
		companyNumberLabel: '香港证监会中央编号',
		businessDirection: '跨境 · 多策略',
		businessDesc: '研究驱动与风险优先的业务取向',
		featureHkHub: '香港枢纽',
		featureHkHubDesc: '依托香港制度、法治与资本流动优势，支撑跨境业务稳健开展。',
		featureResearch: '研究体系',
		featureResearchDesc: '覆盖宏观、资产类别与标的研究，形成多层级投研框架。',
		featureRiskFirst: '风控优先',
		featureRiskFirstDesc: '以风险管理机制为支撑，以全流程监控为保障，提升投资过程中的风险识别与管理能力。',
	},

	// 首页 - 快速了解
	quickLinks: {
		title: '快速了解奥盛',
		subtitle: '了解奥盛资产的公司背景、投资方法、风控体系与全球视野，按需进入相关栏目。',
		about: {
			title: '关于我们',
			desc: '了解奥盛资产的发展历程、公司理念与研究成果。',
		},
		strategy: {
			title: '投资策略',
			desc: '资产配置框架、多策略协同、研究驱动与执行复盘。',
		},
		riskCompliance: {
			title: '风控合规',
			desc: '投前、投中、投后风险管理与制度化合规治理。',
		},
		crossBorder: {
			title: '全球视野',
			desc: '',
		},
	},

	// 首页 - 核心定位
	corePositioning: {
		enTitle: '',
		title: '核心定位',
		subtitle: '面向机构客户与高净值专业投资者，依托香港金融市场优势，连接中国与国际资本市场，服务多市场资产布局。',
		item1Title: '基本面驱动',
		item1Desc: '立足中长期基本面研究，降低短期市场情绪干扰，提升投资决策与组合管理的一致性。',
		item2Title: '风控管理',
		item2Desc: '坚持风险前置，构建投前评估、投中监控、投后复盘的全流程风控闭环。',
		item3Title: '多资产多策略',
		item3Desc: '围绕不同资产类别与多元投资策略进行组合管理，力求提升组合在不同市场周期下的稳定性。',
	},

	// 首页 - 核心能力与服务
	coreServices: {
		enTitle: '',
		title: '核心能力与服务体系',
		subtitle: '依托香港成熟金融环境与市场基础设施，奥盛资产以投研、投资与风控协同为核心，面向机构客户及高净值专业投资者，提供资产配置与投资顾问服务。',
		subtitleNote: '',
		service1Title: '合规稳健运营',
		service1Desc: '坚持在合规框架下稳健运营，持续完善投资管理流程与客户服务体系。',
		service2Title: '全球资产布局',
		service2Desc: '依托香港国际金融中心优势，连接中国与国际资本市场，动态调整组合结构，提升资产组合的稳健性与抗波动能力。',
		service3Title: '研究驱动投资',
		service3Desc: '基于持续研究与市场洞察，形成投资判断，并通过稳健执行推动策略落地。',
		service4Title: '全流程风控',
		service4Desc: '覆盖投前评估、投中监控与投后复盘，持续提升风险识别与应对能力。',
	},

	// 首页 - 为什么是香港
	whyHongKong: {
		enTitle: '',
		title: '为什么是香港',
		subtitle: '香港具备成熟监管、法治环境与自由资本流动机制，是连接中国与国际资本市场的关键枢纽。',
		section1Title: '枢纽优势与市场基础',
		section1Desc: '依托香港国际金融枢纽优势与成熟市场基础设施，奥盛资产在规范市场环境下，持续完善研究、交易与合规流程，支撑长期、稳健、可复盘的资产配置实践。',
		section2Title: '合规管理',
		section2Desc: '奥盛资产坚持合规运营，持续完善证券交易、资产管理与投资顾问服务的业务流程与管理机制。',
		section3Title: '市场联动',
		section3Desc: '依托香港金融市场优势，持续关注中国与国际资本市场变化，提升跨市场研究与配置能力。',
		section4Title: '研究驱动',
		section4Desc: '以全球宏观研究与中国市场洞察为基础，支持多资产、多策略的长期配置实践。',
	},

	// 首页 - 业务体系概览
	businessSystem: {
		enTitle: '01 · 业务体系',
		label: '业务体系',
		title: '业务体系概览',
		subtitle: '奥盛资产围绕**研究**、**投资**与**风控**三大环节，构建协同联动的业务体系。公司在制度约束下推进策略执行，将风险管理嵌入投资全流程，并通过相对独立的监督机制保障业务稳健运行。',
		researchTitle: '市场研判',
		researchDesc: '跟踪宏观与市场变化，形成动态判断。',
		decisionTitle: '投资决策',
		decisionDesc: '结合研究判断与风险约束，推动策略落地。',
		monitorTitle: '风险监控',
		monitorDesc: '动态跟踪组合风险，保障投资稳健运行。',
		ctaStrategy: '查看投资策略',
	},

	// 首页 - 服务方向
	serviceDirection: {
		enTitle: '02 · 服务方向',
		label: '服务方向',
		title: '主要服务方向',
		subtitle: '公司聚焦资产管理、证券投资及投资顾问相关业务，依托系统化投研、资产配置与风险管理能力，为专业投资者提供多元化服务支持。',
		assetManagement: '资产管理',
		assetManagementDesc: '多资产配置，多策略协同。',
		securitiesInvestment: '证券投资',
		securitiesInvestmentDesc: '研究驱动投资，风控保障执行。',
		investmentAdvisory: '投资顾问',
		investmentAdvisoryDesc: '就证券提供意见',
		professionalClient: '客户群体',
		professionalClientDesc: '机构客户与专业投资者',
		professionalClientNote: '服务流程遵循适当性与披露要求。',
		fileDisclosure: '合规披露',
		fileDisclosureDesc: '以正式文件及适用条款为准。',
		ctaContact: '联系我们',
		ctaCrossBorder: '全球视野',
	},

	// 首页 - 官网导览
	siteNav: {
		title: '官网导览',
		subtitle: '通过公司介绍、投资策略、风控合规等栏目，了解奥盛资产的专业优势与服务体系。',
		about: {
			title: '关于我们',
			desc: '走进奥盛资产，了解公司背景、发展历程与公司理念。',
		},
		strategy: {
			title: '投资策略',
			desc: '资产配置框架、多策略组合、研究驱动与执行机制。',
		},
		riskCompliance: {
			title: '风控合规',
			desc: '贯穿投资全过程的风险管理与合规保障。',
		},
	},

	// 首页 - 理念关键词
	philosophyKeywords: {
		enTitle: 'RESEARCH × PORTFOLIO × RISK',
		title: '研究驱动与执行协同',
		subtitle: '公司以研究框架为基础，贯通组合构建与风控执行，推动策略从研究判断到执行管理形成闭环。',
		signature: '通过定期复盘与动态调整组合结构，提升市场响应能力与组合韧性',
		keywords: ['研究驱动', '风险优先', '长期主义', '透明合规'],
		footerText: '奥盛资产坚持合规稳健展业，重视过程纪律与能力沉淀，持续服务专业投资者的长期价值目标。',
		sectionTitle: '我们的投资理念',
		sectionDesc: '奥盛资产坚持合规稳健展业，依托专业积累与系统化管理，持续服务机构与专业投资者的长期价值目标。',
		kw1: '研究驱动',
		kw2: '风险优先',
		kw3: '长期主义',
		kw4: '透明合规',
	},

	// 首页 - 免责声明
	disclaimer: {
		title: '合规先行 · 研究驱动 · 长期主义',
		desc: '本网站内容仅用于公司介绍与业务展示，不构成投资建议、产品推介或任何交易邀请。',
	},

	// 首页 - 常用入口
	commonLinks: {
		title: '常用入口',
		subtitle: '白皮书、策略说明、联络渠道与常见问答，便于快速跳转。',
		whitepaper: {
			title: '白皮书 PDF',
			desc: '在线阅读（新窗口）与下载，了解跨境配置与多策略投资方法论。',
		},
		strategyMethod: {
			title: '投资方法与框架',
			desc: '资产配置、策略协同、执行复盘与迭代机制。',
		},
		contact: {
			title: '联络与接洽',
			desc: '公司注册信息、合规沟通说明与资料入口。',
		},
	},

	// 页脚
	footer: {
		companyName: '奥盛资产管理有限公司',
		companyDesc: '立足香港 · 服务专业投资者的资产管理机构',
		disclaimer: '欢迎通过合规渠道了解公司服务与风险披露。本网站仅供展示，不构成任何投资建议、要约或要约邀请。',
		riskLink: '风控与合规',
		whitepaperLink: '白皮书 PDF',
		slogan: '合规先行 · 研究驱动 · 长期主义',
		copyright: '本网站仅供公司与业务展示，不构成任何投资建议、要约或要约邀请。投资有风险，决策请结合自身情况审慎评估。',
	},

	// 关于我们页面
	about: {
		heroEnTitle: 'ABOUT US · 奥盛资产',
		heroTags: ['香港注册', '成立于2016', '资产管理', '证券投资', '投资顾问'],
		heroSubtitle: '',
		heroTitle: '立足香港，连接中国与全球市场',
		heroDescription: '公司成立于2016年，持续围绕资产管理、证券投资与投资顾问服务，构建覆盖投研、投资与风控的系统化业务框架。',
		enJourney: 'ABOUT US · 奥盛资产管理有限公司',
		journeyTitle: '十余年深耕，体系化投研与风控',
		journeySubtitle: '公司历经十余年发展，逐步形成覆盖多市场、多策略的投研与资产配置能力，并持续强化治理结构、研究深度与全流程风险管理体系，为专业投资者长期价值目标提供支持。',
		layoutTag1: '全球视野',
		layoutTag1Desc: '连接中国与国际资本市场',
		layoutTag2: '多元配置',
		layoutTag2Desc: '覆盖多类资产配置需求',
		layoutTag3: '投研驱动',
		layoutTag3Desc: '支撑多策略投资决策',
		enService: 'Company Vision',
		serviceTitle: '公司愿景',
		serviceSubtitle: '以成为全球一流投资银行为长期目标，持续提升跨境资本服务、全球资产配置与国际市场拓展能力，为客户创造长期、稳健、可持续的价值。',
		serviceSignature: '',
		developmentTitle: '发展脉络',
		developmentSubtitle: '奥盛资产在长期实践中持续完善治理结构、研究深度与风险管理体系。',
		locationTag: '区位',
		locationDesc: '香港金融枢纽与法治基础。',
		timeTag: '时间线',
		timeDesc: '2016 成立至今持续发展。',
		clientTag: '客户',
		clientDesc: '面向专业投资者与机构。',
		hkPositionTitle: '香港区位与全球连接',
		hkPositionDesc: '依托香港国际金融中心优势，连接中国与国际资本市场，持续强化全球视野能力，并以研究、投资与风控协同支撑长期稳健发展。',
		timeline2011: '公司于香港注册成立，开启资产管理业务布局。',
		timeline2016: '强化跨境配置能力，连接境内外市场机会。',
		timelineRecent: '持续强化多资产配置、多策略协同与全流程风险管理能力。',
		whitepaperTitle: '白皮书与影像资料',
		whitepaperSubtitle: '左侧视频快速了解公司定位，右侧白皮书查看完整方法论与业务脉络。',
		videoTitle: '公司视频',
		videoDesc: '以下为奥盛资产宣传视频，可直接在线播放。',
		paperTitle: '白皮书',
		paperDesc: '《全球视野下的跨境资产配置与多策略投资白皮书》在线阅览与下载。为保证页面阅读体验，白皮书不在页面内直接展开。请通过以下方式在线阅读或下载。',
		onlineRead: '在线阅读（新窗口打开）',
		downloadPdf: '下载 PDF',
	},

	// 投资策略页面
	strategy: {
		heroEnTitle: 'INVESTMENT STRATEGY · 投资策略',
		heroTags: ['资产配置', '多策略协同', '研究驱动', '纪律执行', '动态迭代'],
		heroSubtitle: '',
		heroTitle: '研究驱动的多策略投资体系',
		heroDescription: '奥盛资产以资产配置为核心，以风险管理为底层约束，在权益、固收及多元策略之间进行动态权重调整，追求组合长期稳定性。',
		enFramework: 'FRAMEWORK',
		frameworkTitle: '宏观定向与深度研究',
		frameworkSubtitle: '公司结合宏观周期、流动性环境与市场结构判断，确定组合配置方向；同时通过行业比较与标的研究寻找超额收益来源，并依托执行跟踪和持续复盘机制，提升策略的长期适应性与有效性。',
		macroAnchor: '周期研判',
		macroAnchorDesc: '结合宏观周期与流动性环境，明确组合配置方向。',
		midIndustry: '产业洞察',
		midIndustryDesc: '跟踪产业链变化与竞争格局，识别优质投资机会。',
		executionReview: '策略迭代',
		executionReviewDesc: '通过执行跟踪与持续复盘，保障策略长期有效。',
		enResearchPortfolio: 'FROM RESEARCH TO PORTFOLIO',
		rpTitle: '研究成果与组合转化',
		rpDesc1: '将宏观与行业判断转化为权重配置与标的选择，并在风险预算、相关性约束下形成持仓结构。',
		rpDesc2: '通过策略执行与定期复盘，持续检验策略有效性，推动组合动态迭代。',
		sfTitle: '策略框架',
		sfDesc: '通过"宏观判断 - 行业研究 - 标的筛选 - 策略执行"的流程，将研究结论转化为投资策略。',
		mappingTitle: '宏观配置与风险约束',
		mappingDesc: '基于经济周期与流动性判断，转化区域、行业与资产权重，并结合风险预算、相关性约束与集中度管理，提升组合稳健性。',
		mappingDesc2: '在组合管理中加入风险预算与相关性约束，降低策略集中风险。',
		mappingWeight: '权重转化',
		mappingWeightDesc: '将宏观结论转化为区域与资产类别配置比例。',
		mappingBudget: '风险管理',
		mappingBudgetDesc: '基于相关性约束，控制组合集中度与回撤风险。',
		mappingStructure: '持仓框架',
		mappingStructureDesc: '构建可执行、可监控的持仓与限额管理体系。',
		allocLayerTitle: '区域资产配置',
		allocLayerItem1: '从经济周期、政策路径与流动性环境出发。',
		allocLayerItem2: '动态管理区域市场与资产类别权重。',
		allocLayerItem3: '在控制集中度与回撤风险的同时，提升组合配置效率。',
		stratLayerTitle: '多策略组合管理',
		stratLayerItem1: '以权益策略、固定收益策略及多策略协同为核心。',
		stratLayerItem2: '结合长期成长、估值匹配、信用质量与流动性管理。',
		stratLayerItem3: '多降低单一策略波动对整体组合的影响。',
		execTitle: '策略复盘',
		execSubtitle: '强调执行规范与持续复盘，通过绩效评估不断优化研究方法和执行路径。',
		processExec: '策略执行',
		processExecDesc: '以制度与跟踪机制降低策略漂移与人为偏差，提升策略稳定性。',
		multiReview: '多维复盘',
		multiReviewDesc: '关注收益、波动、回撤与执行偏差，持续校准投资框架。',
		iterOptimize: '迭代优化',
		iterOptimizeDesc: '将复盘结论反馈至研究与执行环节，持续优化策略逻辑与流程机制。',
		researchFirst: '研究先行',
		researchFirstDesc: '投资前完成多层级研究评估，避免决策依赖短期情绪。',
		disciplineExec: '投研前置',
		disciplineExecDesc: '在投资决策前完成多层级研究评估，提升判断的系统性与稳定性。',
		reviewOptimize: '策略落地',
		reviewOptimizeDesc: '通过流程化执行控制交易偏差，提升策略落地一致性。',
		bottomLine: '风险管理体系',
		bottomLineDesc: '围绕风险识别、风险评估、敞口管理、回撤控制与合规监测，建立覆盖投资决策、组合管理与执行复盘的全流程风险管理体系。',
	},

	// 风控合规页面
	riskCompliance: {
		heroEnTitle: 'RISK & COMPLIANCE · 风控合规',
		heroTags: ['投前评估', '投中监控', '投后复盘', '职能独立', '合规治理'],
		heroSubtitle: '',
		heroTitle: '风控与合规是资产管理的核心支撑',
		heroDescription: '公司将风险控制与合规管理作为资产管理体系的基础能力，围绕投前评估、投中监控与投后复盘建立全生命周期管理框架，并通过相对独立的风控职能，保障投资决策与组合运行稳健有序。',
		enRiskCulture: 'RISK CULTURE',
		riskCultureTitle: '风险识别先于收益追求',
		riskCultureSubtitle: '对市场风险、流动性风险、信用风险、操作风险与合规风险进行分类管理，并通过制度约束与流程控制保障业务稳健运行。',
		classifiedMgmt: '风险管控',
		classifiedMgmtDesc: '识别、评估、监测与应对闭环。',
		processEmbed: '制度约束',
		processEmbedDesc: '权限、审批与留痕保障规范执行。',
		independentFunc: '流程控制',
		independentFuncDesc: '贯穿投前、投中、投后管理闭环。',
		loopTitle: '风险管理闭环',
		loopSubtitle: '系统识别市场、流动性、信用、操作与合规风险，构建分层管控与持续应对机制。',
		proactiveIdentify: '风险预判',
		proactiveIdentifyDesc: '投前评估情景变化与风险边界。',
		dynamicTrack: '动态监控',
		dynamicTrackDesc: '投中监控敞口与偏离度。',
		closedLoopReview: '闭环复盘',
		closedLoopReviewDesc: '投后总结反馈，推动持续迭代。',
		fullProcessTitle: '全流程风险前置',
		fullProcessDesc1: '公司将风险控制嵌入投前评估、投中监控与投后复盘全流程。',
		fullProcessDesc2: '并通过相对独立的风险管理机制，提升风险判断的客观性与组合运行的稳健性。',
		preInvest: '披露与管理',
		preInvestDesc: '信息透明、客户分类与文件留痕。',
		midMonitor: '培训与文化',
		midMonitorDesc: '持续内训，强化日常合规意识。',
		postReview: '审计与监督',
		postReviewDesc: '独立检视流程执行，推动持续改进。',
		complianceFocusTitle: '合规管理',
		complianceFocusSubtitle: '在适用监管要求下，持续完善内部制度、信息披露与投资者风险匹配机制。',
		governanceTitle: '制度化治理体系',
		governanceDesc: '通过明确职责边界、规范决策流程、持续培训与内部审计，构建可持续的合规治理体系。',
		governanceDesc2: '公司以信息透明、客户风险匹配与服务规范为核心，持续提升服务质量与长期信任。',
		line1Title: '业务一线',
		line1Desc: '第一道防线',
		line2Title: '风险管理',
		line2Desc: '独立监控',
		line3Title: '内审监督',
		line3Desc: '可追溯链条',
		disclosureTitle: '披露与适当性',
		disclosureDesc: '信息透明、客户分类与文件留痕。',
		trainingTitle: '培训与文化',
		trainingDesc: '持续内训与合规意识渗透日常。',
		auditTitle: '审计与监督',
		auditDesc: '第三道防线独立检视与改进。',
		threeLinesTitle: '三道防线治理机制',
		threeLinesDesc: '业务一线、风险管理与内部审计相互制衡，形成可审计、可追溯的治理链条。',
		threeLinesDesc2: '在适用法规框架下，将合规要求嵌入日常流程，推动制度执行形成闭环。',
		systemProcessTitle: '制度与流程',
		systemProcessItem1: '明确投资、风控与合规职责边界。',
		systemProcessItem2: '重大投资决策实行规范审批与留痕管理。',
		systemProcessItem3: '内审监督定期检查流程执行情况。',
		clientInfoTitle: '客户与信息管理',
		clientInfoItem1: '强化客户分类、信息披露与利益冲突管理。',
		clientInfoItem2: '建立沟通机制，保障信息准确及时。',
		clientInfoItem3: '开展合规培训，提升执行一致性。',
		bottomLine: '透明、审慎、可追溯',
		bottomLineDesc: '以信息披露、客户风险匹配与内控监督为核心，推动合规管理融入业务流程与长期经营体系。',
	},

	// 跨境配置页面
	crossBorder: {
		heroEnTitle: 'CROSS-BORDER ALLOCATION · 全球视野',
		heroTags: ['全球宏观', '中国深度', '香港枢纽', '分散化', '动态再平衡'],
		heroTitle: '全球资产视野',
		heroDescription: '奥盛资产依托香港国际金融市场优势，持续关注中国内地与国际资本市场变化，结合全球资产视角与中国市场洞察，稳健开展跨市场资产布局。同时积极拓展中国内地市场，完善投研支持、品牌运营与客户服务体系，推动香港专业资源与内地市场需求有效衔接，助力提升组合应对市场波动的能力。',
		enGlobalAlloc: 'GLOBAL ALLOCATION',
		globalAllocTitle: '全球布局',
		globalAllocSubtitle: '奥盛资产依托香港国际金融市场优势，以全球资产视角连接中国内地与国际市场，推动香港专业资源与内地市场需求深度衔接，持续完善中国内地本地化服务体系。',
		globalView: '持牌机构',
		globalViewDesc: '依托香港专业资质，夯实合规运营基础。',
		dynamicRebal: '香港枢纽',
		dynamicRebalDesc: '连接内地与国际市场，整合跨市场资源。',
		hkHub: '内地拓展',
		hkHubDesc: '完善本地服务体系，提升市场响应能力。',
		enHkHub: 'HONG KONG AS HUB',
		hkHubTitle: '香港优势与全球视野',
		hkHubSubtitle1: '依托香港成熟金融环境，奥盛资产持续关注全球资本市场变化，结合全球宏观判断与中国市场洞察，适时调整组合结构，提升资产配置的稳健性与适应能力。',
		hkHubSubtitle2: '通过组合调整与风险管理机制，应对市场波动与环境变化，力求增强组合韧性。',
		logicLabel: '盛维量研',
		logicSubtitle: '盛维量研是奥盛资产面向量化研究与智能策略服务打造的专业平台，也是奥盛资产拓展中国内地市场的重要业务承接载体。',
		crossMarketTitle: '全球资产视野',
		crossMarketDesc1: '奥盛资产依托香港专业金融资源与跨市场视野，为盛维量研提供市场基础、专业支持与资源协同；盛维量研则围绕策略研究、数据分析、技术服务与客户支持，推动相关能力在内地市场落地。',
		crossMarketDesc2: '通过盛维量研，奥盛资产将香港金融服务优势、量化投研能力与内地本地化运营体系相结合，进一步提升对中国内地市场的服务深度与响应效率。',
		diversification: '战略承接',
		diversificationDesc: '承接奥盛资产内地业务延伸，打造量化研究与智能策略服务平台。',
		cycleMisalign: '资源协同',
		cycleMisalignDesc: '依托香港金融资源，支持盛维量研开展策略研究与资产配置服务。',
		resilience: '本地落地',
		resilienceDesc: '聚焦技术协同、投研内容与客户服务，提升内地市场服务能力。',
		globalAssetViewTitle: '奥盛资产',
		globalAssetViewItem1: '依托香港专业金融机构背景与国际市场资源。',
		globalAssetViewItem2: '发挥香港枢纽优势，连接内地与国际市场。',
		globalAssetViewItem3: '提供专业支持、资源协同与稳健发展基础。',
		chinaDeepTitle: '盛维量研',
		chinaDeepItem1: '聚焦量化研究、智能策略与资产配置服务。',
		chinaDeepItem2: '围绕数据分析、策略研究与风险控制建设体系。',
		chinaDeepItem3: '承接内地运营、技术协同与客户服务支持。',
		crossRiskTitle: '全球市场风控',
		crossRiskSubtitle: '跟踪内地与国际市场变化，结合研究分析与组合调整，提升跨市场配置稳定性。',
		crossRiskMainDesc: '奥盛资产持续关注全球市场政策变化、汇率波动、利率环境与资产价格变化，结合多市场数据跟踪与风险敞口管理，建立动态化风险识别与应对机制，提升跨市场资产配置的稳定性与长期适应能力。',
		crossRiskCardTitle: '全球风险管理',
		crossRiskSignature: '',
		policyRisk: '政策风险监测',
		policyRiskDesc: '持续关注不同市场的监管政策、宏观环境与资金流向变化，提前识别潜在影响因素。',
		exchangeRateRisk: '汇率波动管理',
		exchangeRateRiskDesc: '跟踪主要货币汇率变化，结合跨市场资产配置需求，动态评估汇率波动带来的影响。',
		marketDiff: '市场风险控制',
		marketDiffDesc: '围绕资产价格波动、市场结构差异与风险敞口变化，建立动态调整机制，提升组合稳定性。',
		bottomLine: '发展愿景',
		bottomLineDesc: '立足香港，连接中国内地与国际市场，推动专业金融资源、量化研究能力与本地化服务体系融合，打造稳健、专业、可持续发展的智能策略服务平台。',
	},

	// 联络我们页面
	contact: {
		heroEnTitle: 'CONTACT US · 联络我们',
		heroTags: ['专业服务', '合规沟通', '长期合作'],
		heroTitle: '联络我们',
		heroDescription: '如需业务咨询或合作沟通，欢迎联系我们，我们将及时回应。',
		enContactInfo: 'GET IN TOUCH',
		infoTitle: '期待与您长期互信、稳健同行',
		infoDesc: '正式接洽前，建议您充分了解公司资料、服务范围及相关规范；具体产品条款、权责安排与风险揭示，均以正式法律文件为准。',
		channelLabel: '合规沟通',
		channelDesc: '咨询与合作均通过官方渠道对接。',
		materialLabel: '资料了解',
		materialDesc: '了解公司资料与相关规范，便于后续沟通。',
		locationLabel: '香港主体',
		locationDesc: '注册于香港，遵循适用监管与信息披露要求。',
		enOfficeInfo: 'COMPLIANT COMMUNICATION',
		officeTitle: '以合规为前提的沟通',
		officeDesc1: '重视长期合作关系，业务沟通均在适用法规与客户匹配要求下进行。 ',
		officeDesc2: '建议先了解公司资料与相关规范，再通过官方渠道接洽。 ',
		complianceLabel: '客户匹配',
		complianceDesc: '面向专业投资者与合作机构。 ',
		infoLabel: '信息准确',
		infoDesc2: '以正式文件与官网公告为准。 ',
		responseLabel: '及时回应',
		responseDesc: '业务咨询将在工作日内处理。',
		companyInfoTitle: '公司信息',
		companyName: '公司名称：奥盛资产管理有限公司',
		companyNameEn: '英文名称：A.C Asset Management Limited',
		companyDate: '成立时间：2016 年 04 月 28 日',
		companyRegNo: '',
		companyBizNo: '香港证监会中央编号：BHS283',
		companyLocation: '注册地：香港',
		disclaimerTitle: '联络我们',
		disclaimerDesc: '如需了解更多服务信息，欢迎与我们联系。',
		disclaimerItem1: '客户服务：shengweiliangyan@gmail.com',
		disclaimerItem2: '投诉建议：acasset1215@gmail.com',
		disclaimerItem3: '公司地址：香港金钟夏悫道18号海富中心一座10楼1002C室',
	},

	// 业务介绍
	business: {
		heroEnTitle: 'SOFTWARE DOWNLOAD · 软件下载',
		heroTitle: '软件下载',
		heroDescription: '为专业投资者提供多终端、多平台的交易与信息服务支持。',
		platformTitle: '为用户提供更好、更专业的软件服务平台',
		platformDesc: '盛维量研是香港奥盛资产管理有限公司联合多家技术与研究服务机构共同打造的量化研究与智能策略服务平台，围绕数据分析、策略研究、资产配置与风险控制，构建系统化、可持续的投研服务体系。',
		appClientTitle: '奥盛资产APP客户端',
		methodIosLabel: '苹果',
		iosSearchHint: '（搜索：盛维量研plus）',
		methodAndroidLabel: '安卓',
		androidSearchHint: '（搜索：盛维量研）',
		pcClientTitle: '奥盛资产PC客户端',
		pcClientDesc: '请使用电脑浏览器打开官网下载应用程序',
	},
}